import { getInfo } from "@remotion/google-fonts/NotoColorEmoji";

// Noto Color Emoji comes as ten files, each for a unicode-range. The ads load only the files their captions need, so this
// module stays free of ScreenDive's map and video imports (and the test of it loads neither).

/** "U+23, U+2a, U+30-39" as [[0x23, 0x23], [0x2a, 0x2a], [0x30, 0x39]] */
const parseRanges = (ranges: string): [number, number][] =>
	ranges.split(",").map((part) => {
		const [lo, hi = lo] = part.trim().replace(/^U\+/i, "").split("-");
		return [parseInt(lo, 16), parseInt(hi, 16)];
	});

/**
 * The subsets (keys like "[7]") of the emoji font that cover the emoji in `text`, each once, in the order they are first needed.
 * ASCII and the joiner and variation selector (U+200D, U+FE0F) need no file of their own; a code point no subset has is ignored.
 */
export const emojiSubsets = (text: string): string[] => {
	const subsets = Object.entries(getInfo().unicodeRanges).map(([key, ranges]) => ({ key, ranges: parseRanges(ranges) }));
	const needed = new Set<string>();
	for (const char of text) {
		const cp = char.codePointAt(0) ?? 0;
		if (cp < 0x80 || cp === 0x200d || cp === 0xfe0f) continue;
		const hit = subsets.find(({ ranges }) => ranges.some(([lo, hi]) => cp >= lo && cp <= hi));
		if (hit) needed.add(hit.key);
	}
	return [...needed];
};
